/** `/auth/forgot` — the reset link goes to Link Accounting's own reset page. */
import type { JSX } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AuthLayout, ResetRequestForm, useAuthBranding } from "@linkhr/auth/pages";
import { resolveTenant } from "@linkhr/auth";
import { env } from "../env";

export const Route = createFileRoute("/auth/forgot")({
  component: ForgotRouteComponent,
});

function ForgotRouteComponent(): JSX.Element {
  const navigate = useNavigate();
  const tenantSlug = resolveTenant({ fallbackSlug: env.VITE_DEV_TENANT_SLUG });
  const branding = useAuthBranding(tenantSlug);
  return (
    <AuthLayout branding={branding} product="accounting">
      <ResetRequestForm
        tenantSlug={tenantSlug}
        apiBaseUrl={env.VITE_API_BASE_URL}
        audience="accounting"
        onBack={() => void navigate({ to: "/login" })}
      />
    </AuthLayout>
  );
}
